import type { ReportingEntry } from "@/shared/cache";

/** The reporting API represents reviewed rows as tracked rows with approved=true. */
export function getReportingEntryStatus(
	entry: ReportingEntry,
): "tracked" | "reviewed" | "exported" | "deleted" {
	if (entry.status === "deleted") return "deleted";
	if (entry.status === "exported" || entry.exported) return "exported";
	return entry.approved ? "reviewed" : "tracked";
}
